export const navItems = [
  {
    title: 'HOME',
    href: '/'
  },
  {
    title: 'ABOUT US',
    href: '/about',
    hasDropdown: true,
    subItems: [
      { title: 'Who we are', href: '/about/who-we-are' },
      { title: 'Our History', href: '/about/history' },
      { title: 'Leadership', href: '/about/leadership' },
      { title: 'Legal Foundation', href: '/about/legal-foundation' },
      { title: 'Members Countries', href: '/about/member-countries' }
    ]
  },
  {
    title: 'PROGRAMMES & PRIORITIES',
    href: '/programmes',
    hasDropdown: true,
    subItems: [
      { title: 'Strategic Pillars', href: '/programmes' },
      { title: 'Programmes', href: '/programmes/programs' }
    ]
  },
  {
    title: 'OPPORTUNITIES',
    href: '/opportunities',
    hasDropdown: true,
    subItems: [
      { title: 'Procurement', href: '/opportunities/procurement' },
      { title: 'Careers', href: '/opportunities/careers' }
    ]
  },
  {
    title: 'MEDIA',
    href: '/media/press-release',
    hasDropdown: true,
    subItems: [
      { title: 'Press Release', href: '/media/press-release' },
      { title: 'Photo Gallery', href: '/media/photo-gallery' },
      { title: 'Videos', href: '/media/videos' }
    ]
  },
  {
    title: 'EVENTS',
    href: '/events'
  },
  {
    title: 'RESOURCES',
    href: '/resources'
  }
]